async function fetchProduct(url) {
    // Sayfa değiştikten sonra .header (veya başka bir alan) scroll yapsın
console.info("fetchProduct",url)
  
  // quick-add-modal__content-info quick-add-modal__content-info--bulk
  if (document.getElementById("FacetFiltersForm")) {
    window.location.href = url;
    return;
  }
  
    const mainContent = document.querySelector('.product--medium');
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  
  try {
    const response = await fetch(url);
    const html = await response.text();

    // Yeni gelen HTML'den sadece <body> içeriğini al
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newBody = doc.body;

    // Mevcut body'nin içeriğini değiştir
    document.body.replaceWith(newBody);

      // Sayfa değiştikten sonra .header (veya başka bir alan) scroll yapsın
    const mainContent = document.querySelector('body');
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }

    const oldScript = document.getElementById('nestscale-product-variant-script');
    if (oldScript) {
        const newScript = document.createElement('script');
        newScript.id = 'nestscale-product-variant-script';
        newScript.src = oldScript.src;
        newScript.async = oldScript.async;
        newScript.defer = oldScript.defer;
    
        oldScript.parentNode.removeChild(oldScript);
        document.head.appendChild(newScript);
    }

  

  } catch (err) {
    console.error('Sayfa yüklenemedi:', err);
  }
}
